import { consolidationPeriodMode } from "../../../utils/consolidationViewStorage.js";

export function periodDays(from, to) {
  const days = [];
  for (const date = new Date(`${from}T12:00:00Z`); date.toISOString().slice(0, 10) <= to; date.setUTCDate(date.getUTCDate() + 1)) days.push(date.toISOString().slice(0, 10));
  return days;
}

// Mots de la période affichée (Jour, Semaine, Mois) : « Semaine de l’équipe », « Horaire du mois », « ← Mois de … ».
export function periodWords(from, to) {
  const mode = consolidationPeriodMode(from, to);
  return mode === "day" ? { noun: "Journée", of: "de la journée" } : mode === "week" ? { noun: "Semaine", of: "de la semaine" }
    : mode === "month" ? { noun: "Mois", of: "du mois" } : { noun: "Période", of: "de la période" };
}

export function aggregateHours(rows) {
  const employees = new Map(), unidentified = [];
  for (const row of rows) {
    if (!row.employee_id) { unidentified.push(row); continue; }
    if (!employees.has(row.employee_id)) employees.set(row.employee_id, { id: row.employee_id, name: row.employee_name, shift: row.employee_shift, days: new Map(), total: 0, nonBillable: 0, partial: false, hasHours: false });
    const employee = employees.get(row.employee_id);
    employee.days.set(row.work_date, row);
    if (row.total_seconds != null) { employee.total += Number(row.total_seconds); employee.hasHours = true; }
    employee.nonBillable += Number(row.non_billable_seconds || 0);
    employee.partial ||= Boolean(row.total_partial) || row.total_seconds == null;
  }
  return { employees, unidentified };
}

export function periodTotal(employee) {
  return { total_seconds: employee.hasHours ? employee.total : null, total_partial: employee.hasHours && employee.partial, sources: [], expected: [] };
}
